const selectors = {
    getChannel: ({ internal } = {}) => internal?.channel,
    getOrigin: ({ internal } = {}) => internal?.origin,
}

export default selectors
